import React from 'react';
import flavia from '../assets/flavia.png'
import jesica from '../assets/jesica.png'
import amanda from '../assets/amanda.png'

const CardTeamMembers = () => {
  return (
    <div className="w-full bg-white py-10 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
         
        <div className="flex flex-col items-center bg-gray-100 p-6 rounded-lg shadow-lg">
          <img src={jesica} alt="Jéssica Gomes" className="w-full h-auto object-center rounded-t-lg" />
          <div className="mt-4 text-justify">
            <h3 className="text-xl font-bold text-gray-800">Jéssica Gomes</h3>
            <p className="text-gray-600">Fonoaudióloga há 8 anos, especialista em Nutrição Clínica com 7 anos de experiência na Fonoaudiologia hospitalar.</p>
            <p className="text-gray-600">Foco no tratamento da disfagia em adultos e neonatologia.</p>
            <p className='font-semibold pt-1'>CRFa. 4-12185</p>

          </div>
        </div>

        <div className="flex flex-col items-center bg-gray-100 p-6 rounded-lg shadow-lg">
          <img src={flavia} alt="Flávia Neves" className="w-full h-auto object-center rounded-t-lg" />
          <div className="mt-4 text-justify">
            <h3 className="text-xl font-bold text-gray-800">Flávia Neves</h3>
            <p className="text-gray-600">Fonoaudióloga há 15 anos, especialista em UTI com 8 anos de experiência na Fonoaudiologia hospitalar.</p>
            <p className="text-gray-600">Especializações adicionais: Cuidados Paliativos e Motricidade Orofacial.</p>
            <p className="text-gray-600">Foco no tratamento da disfagia em adultos e idosos.</p>
            <p className='font-semibold pt-1'>CRFa. 4-10393</p>
          </div>
        </div>
        
        <div className="flex flex-col items-center bg-gray-100 p-6 rounded-lg shadow-lg">
          <img src={amanda} alt="Amanda Nery" className="w-full h-auto object-center rounded-t-lg" />
          <div className="mt-4 text-justify">
            <h3 className="text-xl font-bold text-gray-800">Amanda Nery</h3>
            <p className="text-gray-600">Fonoaudióloga há 10 anos, especialista em
            Fonoaudiologia  hospitalar com ênfase em Neonatologia, com 7 anos de experiência na área hospitalar.</p>
            <p className="text-gray-600">Foco no tratamento da disfagia em adultos e neonatologia.</p>
            <p className='font-semibold pt-1'>CRFa. 4-11947</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardTeamMembers;
